import HttpStatus from "http-status-codes";
import { type NextApiHandler } from "next";
import { number, object } from "yup";
import { type ApiRoute } from "~/hooks/useApi";
import { api } from "~/lib/api";
import { createMutation, invalidateQuery } from "~/lib/reactQuery";
import { type YupOutputType } from "~/lib/utils";
import { FETCH_FILTERS_PRESETS_QUERY_KEY } from "~/pages/api/filters-preset/fetch-filters-presets";
import {
  type DeleteFiltersPresetResult,
  deleteFiltersPreset,
} from "~/services/market-data/market-data-filters/deleteFiltersPreset";

export const DeleteFiltersPresetSchema = object({
  presetId: number().required(),
}).noUnknown();

export type DeleteFiltersPresetInput = YupOutputType<typeof DeleteFiltersPresetSchema>;

const handler: NextApiHandler<DeleteFiltersPresetResult> = async (req, res) => {
  const input = DeleteFiltersPresetSchema.validateSync(req.body, { abortEarly: false });

  const presets = await deleteFiltersPreset(req, input);

  return res.status(HttpStatus.OK).json(presets);
};

export default api(handler, {
  method: "POST",
  authentication: {
    canAccessMarketData: true,
  },
});

export const DELETE_FILTERS_PRESET_QUERY_KEY: ApiRoute["pathname"] = "/api/filters-preset/delete-filters-preset";

export const useDeleteFiltersPresetMutation = createMutation<typeof handler, typeof DeleteFiltersPresetSchema>({
  path: DELETE_FILTERS_PRESET_QUERY_KEY,
  schema: DeleteFiltersPresetSchema,
  options: ({ queryClient }) => ({
    onSuccess: async () => {
      await invalidateQuery(queryClient, FETCH_FILTERS_PRESETS_QUERY_KEY);
    },
  }),
});
